import { createQueryDefinition, createQueryHook } from '../queryBuilder';
import { get } from './api';

export const GetThemeQuery = createQueryDefinition(
  (eventId: string | number) => ['theme', eventId],
  ({ queryKey: [, eventId] }) => eventId && get(eventId)
);

export const useEventSpaceThemeQuery = createQueryHook(GetThemeQuery, {
  select: ({ data }) => data.theme,
});
